import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { primaryNavItems } from '../config/nav';
import { cn } from '../ui/cn';

const isPathActive = (pathname: string, itemPath: string): boolean => {
  if (itemPath === '/') {
    return pathname === '/';
  }

  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
};

const Sidebar: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <aside className="hidden h-screen border-r border-border bg-surface md:sticky md:top-0 md:flex md:w-60 md:flex-col">
      <div className="border-b border-border px-5 py-6">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-muted">
          EcoVoz
        </p>
        <p className="mt-1 text-lg font-semibold text-text">Navegacao</p>
      </div>

      <nav className="flex-1 px-3 py-4" aria-label="Primary Sidebar">
        <ul className="space-y-1">
          {primaryNavItems.map((item) => {
            const active = isPathActive(pathname, item.path);
            return (
              <li key={item.id}>
                <NavLink
                  to={item.path}
                  end={item.path === '/'}
                  aria-current={active ? 'page' : undefined}
                  className={cn(
                    'flex min-h-11 items-center gap-3 rounded-xl border border-transparent px-3 py-2 text-sm font-medium',
                    'text-muted transition hover:bg-surface2 hover:text-text',
                    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-bg',
                    active &&
                      'border-border bg-surface2 text-text shadow-sm',
                  )}
                >
                  <span
                    className={cn(
                      'inline-flex h-8 w-8 items-center justify-center rounded-lg border border-borderSoft bg-surface text-muted',
                      active &&
                        'border-primary bg-primary text-primaryFg',
                    )}
                  >
                    <item.icon className="h-4 w-4" aria-hidden="true" />
                  </span>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
